'use strict'

import React from 'react'
import { ChrofyShowErrors } from '../../../common/Form'

/**
 * 固定値フォーム本体（controlled）。§4.1, §7.1–7.2, §8.1
 *
 * @param {{
 *   value?: { constant?: string }
 *   errors?: Record<string, string[]>
 *   onChange: (formData: { constant: string }) => void
 * }} props
 */
export const ConstantForm = ({ value = { constant: '' }, errors = {}, onChange }) => {
  const constant = (value.constant ?? '').toString()

  return (
    <div className="text-h7">
      <div className="form-table">
        <table className="w-full">
          <tbody>
            <tr>
              <th className="form-table__col-head w-[150px]">
                <label htmlFor="constant-form-fixed-value" className="text-h7 font-bold">
                  固定値 <span className="red--text">*</span>
                </label>
              </th>
              <td className="form-table__col-data">
                <input
                  id="constant-form-fixed-value"
                  type="text"
                  className={`text-input w-full text-left${errors.constant?.length ? ' is-error' : ''}`}
                  value={constant}
                  onChange={(e) => onChange({ constant: e.target.value })}
                  placeholder="設定したい固定値を入力"
                />
                <ChrofyShowErrors errors={errors} field="constant" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}
